module.exports = {
	"naslov": "Ustaničke borbe",
	"slika": "fotke/1941/1941-10-kraljevo-opsada.jpg",
	"opis": "Tvoj odred je naneo teške gubitke Nemcima u borbama za Kraljevo. Opkoljeni, okupatori masovno streljaju nedužne civile u gradu. Tvoja porodica je ostala u gradu.",
	"pitanje": "Šta ćeš učiniti?",
	"izbori": [
		{
			"opis": "Pritajiću se u šumi.",
			"link": "pritajeni"
		},
		{
			"opis": "Napadaću krvnike još žešće.",
			"link": "odmetnuti-cetnici"
		},
		{
			"opis": "Vratiću se doma.",
			"link": "kuca3"
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/hronologija/1941/10-10/podaci.json
// module id = 46
// module chunks = 0